import React, {useEffect, useMemo, useState} from "react";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {Link, useParams} from "react-router-dom";
import {LoggedInView} from "../common/LoggedInView";
import StarRatingComponent from 'react-star-rating-component';
import {RequestStatus} from "../../utils/Enums";
import {createRating, resetCreateRatingStatus} from "../../store/reducers/OrdersSlice";
import {BreadcrumbLink} from "../../models/BreadcrumbLink";
import Breadcrumbs from "../common/Breadcrumbs";

interface RateOrderScreenProps {
}

export const RateOrderScreen: React.FC<RateOrderScreenProps> = () => {

    const dispatch = useAppDispatch();
    const routeParams = useParams<{ id: string }>();

    const [success, setSuccess] = useState<boolean>(false);

    const ordersState = useAppSelector((state) => state.orders);

    const createRatingSgtatus = ordersState.createRatingStatus;

    useEffect(() => {

        if (createRatingSgtatus === RequestStatus.Success) {
            setSuccess(true);
            dispatch(resetCreateRatingStatus());
        }

    }, [createRatingSgtatus])

    const [rating, setRating] = useState<number>(0);
    const [comment, setComment] = useState<string>("");

    const onStarClick = (nextValue: number) => {
        setRating(nextValue);
    };

    const breadcrumbLinks: BreadcrumbLink[] = useMemo(() => [
        {text: "Veod", url: "/orders"},
        {text: "Hankija kontakti hindamine", url: `/orders/${routeParams.id}/rate`},
    ], [routeParams.id]);

    const handleCommentChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setComment(event.target.value);
    };

    const handleSubmit = () => {
        if (routeParams.id) {
            dispatch(createRating({ id: routeParams.id, rating, comment }));
        }
    };

    return (
        <LoggedInView fullWidth={true}>
            <Breadcrumbs links={breadcrumbLinks}/>
            {success && <div className="message msg-ok">
              <div>
                <h2>Hinnang sisestatud</h2>
              </div>
            </div>}
            {!success &&
            <div>
              <table className="form">
                <tbody>
                <tr>
                  <th>Hinnang</th>
                  <td>
                    <StarRatingComponent
                      name="rate"
                      starCount={10}
                      value={rating}
                      onStarClick={onStarClick}
                    />
                  </td>
                </tr>
                <tr>
                  <th>Kommentaar</th>
                  <td>
                                <textarea
                                  placeholder=""
                                  value={comment}
                                  onChange={handleCommentChange}
                                />
                  </td>
                </tr>
                <tr>
                  <th></th>
                  <td>
                    <button type="button" onClick={handleSubmit}>
                                    <span>
                                        <strong>Sisesta</strong>
                                    </span>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            }
        </LoggedInView>
    );
};